
































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  blacklistNewEditor,
  deleteBlacklist,
  blacklistList,
  getSignatureArea
} from '@/api/developer/developer-private/private'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  deepCopy
} from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
  @Component({
    name: 'DeveloperPirvateSignature'
  })
export default class extends mixins(DateOption) {
    // api data
    private params = {
      udid: '',
      areaCode: '',
      createDateStart: '',
      createDateEnd: '',
      page: 1,
      pageCount: 20
    }
    private addParams = {
      id: 0,
      areaCode: 'US',
      udid: '',
      email: '',
      tutuUid: ''
    }
    // component data
    tableLoading = false
    tableHeight: number = 500
    loadingText = ''
    // private statusMap: Map<String, String> = new Map([['签名通过', 'six'], ['苹果限制 24~72h', 'seven'], ['苹果限制 7~30d', 'seven'],['排队中', 'five']])
    private tableData: any[] = []
    private areaList: any[] = []
    private addFormVisible: boolean = false
    private selectedData: any[] = []
    private dateArray: string[] = ['', '']
    private totalCount = 0
    private config: any = {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    }
    // lifecycle
    async created() {
      this.getTableData()
      this.getAreaList()
      this.$nextTick(() => {
        this.setTableHeight()
        window.addEventListener('resize', this.setTableHeight)
      })
    }
    beforeDestroy() {
      window.removeEventListener('resize', this.setTableHeight)
    }
    // methods
    async getTableData() {
      const mock: any[] = [{
        id: 1424322
      }]
      try {
        this.tableLoading = true
        let res: any = await blacklistList(this.params)
        this.tableData = res.data.dataList || []
        this.totalCount = res.data.pageInfo.totalCount
        // this.tableData = mock
      } catch (error) {
        this.$message.error(error as string)
      } finally {
        this.tableLoading = false
      }
    }
    async handleExcel() {
      let excelParams = deepCopy(this.params)
      this.loadingText = '正在拼命加载...'
      this.tableLoading = true
      try {
        let res: any = await blacklistList(
          Object.assign(excelParams, {
            page: 1,
            pageCount: 100000
          })
        )
        if (res.status.code === 0) {
          setTimeout(() => {
            this['$message'].success('导出成功!')
          }, 200)
        } else {
          this['$message'].error('导出失败!')
          return
        }
        const filterVal: string[] = [
          'udid',
          'areaCode',
          'tutuUid',
          'operator',
          'createDate'
        ]
        const theader: string[] = [
          '设备号',
          '签名地区',
          '兔兔账号',
          '操作人',
          '创建时间'

        ]
        const list = res.data.dataList
        const data = formatJson(filterVal, list)
        exportJson2Excel(theader, data)
      } catch (error) {
        this['$message'].error(error as string)
      } finally {
        this.tableLoading = false
        this.loadingText = ''
      }
    }
    async getAreaList() {
      let res: any = await getSignatureArea()
      this.areaList = res.data.dataList
    }
    deleteAccount(ids: string) {
      this.$confirm('确认删除该数据?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          let res: any = await deleteBlacklist({
            ids: ids
          })
          if (res.status.code === 0) {
            this['$message'].success('删除成功')
            this.getTableData()
          } else {
            this['$message'].error('删除失败')
          }
        })
        .catch(() => {})
    }
    setTableHeight() {
      const filter: any = this.$refs.filter
      const filterDom: any = filter.$el
      this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
    }
    async addEditAccount() {
      let res: any = await blacklistNewEditor(this.addParams)
      if (res.status.code === 0) {
        this['$message'].success('提交成功!')
        this.cancelAddForm()
        this.getTableData()
      } else {
        this['$message'].error('提交失败!')
      }
    }
    handleAdd() {
      this.addFormVisible = true
    }

    handleFormClose() {
      this.cancelAddForm()
    }
    cancelAddForm() {
      this.addParams = {
        id: 0,
        areaCode: 'US',
        udid: '',
        email: '',
        tutuUid: ''
      }
      this.addFormVisible = false
    }
    confirmAddForm() {
      let valid = this.addParams.udid && this.addParams.areaCode
      if (valid) {
        this.addEditAccount()
      } else {
        return this['$message'].warning('请填写完成后再提交!')
      }
    }
    setRemove(item: any) {
      let ids = item.id.toString()
      this.deleteAccount(ids)
    }
    setRemoveAll() {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        let res: any = await deleteBlacklist({ ids: this.selectIds })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
    }
    handleDateChange(date: string[]) {
      this.params.createDateStart = date && date[0]
      this.params.createDateEnd = date && date[1]
    }
    handleSearch() {
      if (this.tableLoading) { return false }
      let params:any = { ...this.params }
      for (let i in params) {
        if (typeof params[i] === 'string') {
          params[i] = params[i].trim()
        }
      }
      this.params = params
      this.params.page = 1
      this.getTableData()
    }
    handleReset() {
      resetObjValue2NoneString(this.params, ['page', 'pageCount'])
      this.params.page = 1
      this.dateArray = ['', '']
      this.getTableData()
    }
    handleCopy(event: any) {
      let text: string = event.target.dataset['clipboardText'] // 使用大驼峰命名法获取
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', text)
      input.select()
      try {
        var flag = document.execCommand('copy') // 执行复制
        this.$message.success('复制成功')
      } catch (err) {
        flag = false
        this.$message.warning('复制失败')
      }
      document.body.removeChild(input) // 删除元素
      return flag
    }
    handleSelectionChange(list: any[]) {
      this.selectedData = list
    }
    handleSelectAll() {
      // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
      if (this.selectedData.length < this.tableData.length) {
        let tempSelectList = this.selectedData.map(item => item.id)
        let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
        unSelected.forEach(row => {
          (this.$refs['multiTable'] as any).toggleRowSelection(row)
        })
      } else {
        (this.$refs['multiTable'] as any).clearSelection()
      }
    }
    handleSelectReverse() {
      this.selectedData = []
      let tempList: number[] = []
      let tempSelectList: number[] = []
      let indexList: number[] = []
      tempList = this.tableData.map(item => item.id)
      tempSelectList = this.selectedData.map(item => item.id)
      indexList = tempList.filter(item => !tempSelectList.includes(item))
      this.tableData.forEach(item => {
        if (indexList.includes(item.id)) this.selectedData.push(item)
      })
      if (this.selectedData.length) {
        this.selectedData.forEach(row => {
          (this.$refs['multiTable'] as any).toggleRowSelection(row)
        })
      } else {
        (this.$refs['multiTable'] as any).clearSelection()
      }
    }

    crypt(str: string) {
      return str.substring(0, 3) + '●●●●' + str.substring(str.length - 3, str.length)
    }

    // computed
    get showMultiSelect() {
      return this.selectedData.length > 1
    }
    get selectCount() {
      return this.selectedData.length
    }
    get selectIds() {
      let t: number[] = []
      this.selectedData.forEach(item => {
        t.push(item.id)
      })
      let ids = t.join(',')
      return ids
    }
}
